<template>
	<div class="container__menu">
		<MenuOptions />
		<div
			id="app"
			class="container__menu__lang"
		>
			<LanguageSelector />
		</div>

		<MenuUserNotifications />
	</div>
</template>

<script>
import MenuOptions from './MenuOptions/MenuOptions'
import MenuUserNotifications from './MenuUserNotifications/MenuUserNotifications'
import LanguageSelector from '../LanguageSelector/LanguageSelector.vue'

export default {
	components: { MenuOptions, MenuUserNotifications, LanguageSelector },

	methods: {
		mudarIdioma() {
			const idioma = this.$i18n.locale === 'ptbr' ? 'es' : 'ptbr'
			localStorage.setItem('idioma', idioma)
			this.$i18n.locale = idioma
		},
	},
}
</script>

<style scoped>
.container__menu {
	width: 100%;
	/* mesma largura do conteúdo da página (ContentBody), para a navbar
	   alinhar com os cards e não espalhar demais os itens do menu */
	max-width: 1200px;
	margin: 0 auto;
	height: fit-content;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
	padding: 0 2rem;
}

@media screen and (min-width: 992px) {
	/* a linha ocupa a altura toda da barra: assim o item do menu encosta na
	   borda de baixo e não sobra faixa morta até o submenu, que abre ali */
	.container__menu {
		height: 100%;
	}
}

@media screen and (min-width: 1200px) {
	.container__menu {
		padding: 0;
	}
}

/* o menu ocupa toda a sobra da linha e distribui os itens dentro dela.
   Assim os ícones ficam sempre na borda direita, sem vão entre o último item
   e o globo, independente de o cliente ter todos os módulos (sem os selos
   "Upgrade", o menu é ~250px mais estreito). */
.container__menu > .container__menuoptions {
	flex: 1 1 auto;
	min-width: 0;
	width: auto;
}

/* globo e bloco do usuário (sino + avatar) nunca colapsam nem somem */
.container__menu__lang,
.container__menu > .container__menuuser {
	flex-shrink: 0;
}

.container__globe__icon {
	cursor: pointer;
}
</style>
